<template>
  <div>
    <vue-slider
      class="calculateur-slider"
      :class="[
        formatedOptions.some(option => option.length > 18)
          ? 'calculateur-slider--small-labels'
          : ''
      ]"
      v-model="selectedFormatedOption"
      :data="formatedOptions"
      :marks="true"
      :contained="true"
      :useKeyboard="true"
      :tooltip="'none'"
      :process-style="{ backgroundColor: '#21acb8' }"
      :railStyle="{
        height: '30px',
        boxShadow: 'inset 0px 3px 7px 0px rgba(0, 0, 0, 0.2)'
      }"
      @change="onChange"
      autofocus
    />
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  components: {
    VueSlider
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    result: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      selectedOption: this.result ? this.result : this.options[0]
    };
  },
  computed: {
    formatedOptions() {
      return this.options.map(option => option.title);
    },
    selectedFormatedOption: {
      get() {
        return this.selectedOption ? this.selectedOption.title : null;
      },
      set(label) {
        this.selectedOption = this.options.find(
          option => option.title == label
        );
      }
    }
  },
  beforeMount() {
    this.onChange();
  },
  methods: {
    onChange() {
      this.$emit("change", this.selectedOption);
    }
  }
};
</script>

<style lang="scss" scoped>
.calculateur-slider {
  &,
  *,
  *::before,
  *::after {
    box-sizing: initial !important;
  }
}
</style>

<style lang="scss">
.calculateur-slider {
  margin: 0 30px;
  margin-bottom: 100px;
  margin-top: 10px;
  max-width: 70%;
  margin-left: auto;
  margin-right: auto;

  @include media(">=tablet") {
    max-width: 80%;
    margin-top: 10px;
    margin-bottom: 90px;
  }

  .vue-slider-mark-step {
    background: rgba(0, 0, 0, 0.1);
  }

  .vue-slider-mark,
  .vue-slider-mark-step {
    width: 1px;
    border-radius: 0;
  }

  &.vue-slider-ltr {
    .vue-slider-mark-label {
      text-align: center;
      white-space: normal;
      transform: translateX(-50%) scale(0.8);
      transition: all 0.5s $s-transition-easing-bounce;
      margin-top: 20px;
      font-size: 24px;
      width: 150px;

      @include media(">=tablet") {
        margin-top: 20px;
        font-size: 32px;
        width: 200px;
      }

      @include media(">=desktop") {
        width: 240px;
      }

      &-active {
        color: $c-primary;
        transform: translateX(-50%) scale(1);
      }
    }

    &.calculateur-slider--small-labels {
      .vue-slider-mark-label {
        font-size: 18px;

        @include media(">=tablet") {
          font-size: 24px;
        }
      }
    }

    .vue-slider-dot {
      width: 42px !important;
      height: 42px !important;

      @include media(">=tablet") {
        width: 60px !important;
        height: 60px !important;
      }
    }

    .vue-slider-dot-handle {
      background: $c-primary;
      box-shadow: 0px 5px 4.5px 0.5px rgba(0, 0, 0, 0.2);

      &-focus {
        box-shadow: 0px 5px 4.5px 0.5px rgba(0, 0, 0, 0.2);
      }

      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: $c-white;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
